import { useEffect, useState } from "react";

const WORDS = ["Ships", "Builds", "Drives", "Owns"];

export const LetterLine = ({ text, className }) => (
  <span className={className} aria-hidden="true">
    {[...text].map((ch, i) => (
      <span key={`${ch}-${i}`} className={ch === " " ? "h-letter h-space" : "h-letter"} style={{ "--i": i }}>
        {ch === " " ? "\u00a0" : ch}
      </span>
    ))}
  </span>
);

const word = (text) => (
  <span className="roll-word" key={text}>
    {[...text].map((ch, i) => (
      <span className="h-letter" key={`${text}-${ch}-${i}`}>
        {ch}
      </span>
    ))}
  </span>
);

export const HeadlineRoll = () => {
  const [index, setIndex] = useState(0);
  const [outgoing, setOutgoing] = useState(null);
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    if (outgoing) return undefined;
    const hold = window.setTimeout(() => {
      setOutgoing(WORDS[index]);
      setIndex((i) => (i + 1) % WORDS.length);
    }, 900);
    return () => window.clearTimeout(hold);
  }, [index, outgoing]);

  useEffect(() => {
    if (!outgoing) return undefined;
    const frame = requestAnimationFrame(() => setOffset(true));
    const done = window.setTimeout(() => {
      setOutgoing(null);
      setOffset(false);
    }, 560);
    return () => {
      cancelAnimationFrame(frame);
      window.clearTimeout(done);
    };
  }, [outgoing]);

  return (
    <span className="h-line designer" id="scramble" aria-hidden="true">
      <span
        className="roll"
        style={{
          transform: offset ? "translateY(-1.2em)" : "none",
          transition: offset ? "transform 560ms cubic-bezier(0.22, 1.15, 0.36, 1)" : "none",
        }}
      >
        {outgoing ? word(outgoing) : null}
        {word(WORDS[index])}
      </span>
    </span>
  );
};
